import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=6495dd8d&scoped=true&"
import script from "./setting.js?vue&type=script&lang=js&"
export * from "./setting.js?vue&type=script&lang=js&"
import style0 from "./setting.scss?vue&type=style&index=0&id=6495dd8d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6495dd8d",
  null
  
)

export default component.exports